import { useStyles } from './styles'
import { ClinicLogo } from '../ClinicLogo'
import { getCache } from '@/utils/cache'

export const MobileHeader: React.FunctionComponent = () => {
  const styles = useStyles()
  const uniqueCode = getCache<string>('unique-code')

  return (
    <div css={styles.boxLogoConexa}>
      <ClinicLogo uniqueCode={uniqueCode} />
    </div>
  )
}
